import {
    createBrowserRouter,
    RouterProvider,
    LoaderFunctionArgs,
    redirect
} from "react-router";

import * as ReactDOM from "react-dom/client";

import "./base.css";
import Dashboard from "./components/Dashboard";
import Root from "./components/Root";
import Device from "./components/Device";
import SitePage from "./components/SitePage";
import LoginPage from "./components/LoginPage";
import NewProjectPage from "./components/NewProjectPage";

import { getSiteWithGenerationSummary, getProjectWithGenerationSummary } from "./features/energy/api";
import ProjectPage from "./components/ProjectPage";
import { ErrorBoundary } from "./components/Error";
import { getCurrentUser } from "./api";
import SettingsPage from "./features/users/components/SettingsPage";
import { ProjectWithGenerationSummary, SiteWithGenerationSummary } from "./types";
import RegistrationPage from "./features/system_registration/components/RegistrationPage";
import InstallerInvitationPage from "./features/system_registration/components/InstallerInvitationPage";
import InvitationSendFormPage from "./features/system_registration/components/InvitationSendFormPage";

const router = createBrowserRouter([
    {
        path: "/login",
        Component: LoginPage
    },
    {
        path: "/",
        Component: Root,
        loader: async () => {
            if (window.location.pathname.includes('/site-connect-invitation/')) {
                return { user: null, error: null };
            }
            try {
                const user = await getCurrentUser();
                return { user, error: null };
            } catch (err) {
                return redirect("/login");
            }
        },
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: 'dashboard',
                errorElement: <ErrorBoundary />,
                Component: Dashboard,
                children: [
                    {
                        path: 'project/new',
                        Component: NewProjectPage
                    },
                    {
                        path: 'project/:projectId',
                        loader: async ({ params }: LoaderFunctionArgs) => {
                            const projectWithGenerationSummary: ProjectWithGenerationSummary = await getProjectWithGenerationSummary(params.projectId!);
                            return { projectWithGenerationSummary };
                        },
                        Component: ProjectPage,
                        children: [
                            {
                                path: 'invite',
                                Component: InvitationSendFormPage
                            },
                            {
                                path: 'register',
                                Component: RegistrationPage
                            },
                            {
                                path: 'installers',
                                Component: InstallerInvitationPage
                            }
                        ]
                    },
                    {
                        path: 'site/:siteId',
                        Component: SitePage,
                        loader: async ({ params }: LoaderFunctionArgs) => {
                            const siteWithGenerationSummary: SiteWithGenerationSummary = await getSiteWithGenerationSummary(params.siteId!);
                            return { siteWithGenerationSummary };
                        }
                    },
                    {
                        path: 'device/:deviceId',
                        Component: Device
                    }
                ]
            },
            {
                path: 'settings',
                Component: SettingsPage
            },
            {
                path: 'site-connect-invitation/:token/',
                Component: RegistrationPage
            }
        ]
    }
]);

const root: HTMLElement | null = document.getElementById("root");

if (root) {
    ReactDOM.createRoot(root).render(
        <RouterProvider router={router} />
    );
}